<template>
  <section class="default-layout">
    <router-view />
  </section>
</template>

<script>
export default {
  name: 'EmptyLayout',
}
</script>
